// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xm3U","expireSoon":"styles_expireSoon__2tdIQ"};